// extracted by mini-css-extract-plugin
export default {"service_main":"S2_Services_service_main__fKSUr","service_header_text":"S2_Services_service_header_text__ZW05J","service_Desc_text":"S2_Services_service_Desc_text__TjlUA"};